<template>
  <div class="exhibits_list" v-if="List.length">
    <div class="title">
      <img src="../../../assets/img/new/icon-brand-l.png"  />
      <span>Product</span>
      <img src="../../../assets/img/new/icon-brand-r.png"  />
    </div>
    <div class="ex_list">
      <div
        class="item_div"
        v-for="item in List"
        :key="item.id"
        @click="LinkProduct(item.id)"
      >
        <div class="img_div">
          <div class="d_tag" v-if="item.view3DUrl">
            <i class="iconfont icon-d"></i>3D
          </div>
          <div class="img-v" v-if="item.panoramaUrl">
            <i class="iconfont icon-VR1"></i>
          </div>
          <div
            class="play_video"
            v-if="item.video && JSON.parse(item.video).url"
          >
            <i class="iconfont icon-zhibo"></i>
          </div>
          <img v-if="item.video && JSON.parse(item.video).url" :src="JSON.parse(item.video).cover" >
          <img
            v-else-if="item.banner[0]"
            :src="item.banner[0]"
            v-load="'oProSmall'"
            
          />
          <img v-else src="@/assets/img/empty.png"  />
        </div>
        <div class="item_info">
          <p class="van-ellipsis name">{{ item.name }}</p>
          <p class="item_text" v-if="item.categoryEn">{{ item.categoryEn}}</p>
          <!-- <p class="item_text" v-else-if="item.category">{{ item.category }}</p> -->
          <p class="item_text van-multi-ellipsis--l2" v-if="item.selling">
            {{ item.selling}}
          </p>
          <!-- <p class="item_text van-multi-ellipsis--l2" v-if="item.selling">
            {{ item.selling }}
          </p> -->
        </div>
      </div>
    </div>
    <!-- <div v-else style="padding: 0.3rem 0 0.5rem;text-align: center;">暂无内容</div> -->
    <div class="more_btn loading" v-if="Loading && !finished">
      <img src="@assets/img/new/icon-loading.png" />Loading...
    </div>
    <div class="more_btn" @click="loadMore" v-else-if="!finished">
      MORE<i class="iconfont icon-right-fill"></i>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "exhibits-list",
  data() {
    return {
      Loading: false, //展品动态加载状态
      finished: false, //展品加载是否完成状态
      List: [], //展品列表
      pageIndex: 1,
      pageSize: 3,
      queryProduct: {},
    };
  },
  components: {},
  computed: {
    ...mapGetters({}),
    exhibitorId() {
      return this.$route.params.id;
    },
  },
  created() {
    this.List = [];
    this.getData();
  },
  methods: {
    ...mapActions({
      LinkProduct: "linkTo/LinkProduct",
    }),
    getProCate(cateJson) {
      let str = cateJson.Value;
      if (cateJson.lists && cateJson.lists.length) {
        str += "/" + this.getProCate(cateJson.lists[0]);
      }
      return str;
    },
    getData(isLoad = false) {
      let query = gql`
        query queryProduct(
          $page: Int!
          $size: Int!
          $where: String!
          $order: String
        ) {
          queryProduct(
            query: { page: $page, size: $size, where: $where, order: $order }
          ) {
            hasNextPage
            indexFrom
            pageIndex
            pageSize
            items {
              id
              name
              nameEn
              selling
              sellingEn
              category
              categoryEn
              isShow
              banner
              view3DUrl
              panoramaUrl
              video
            }
          }
        }
      `;
      let where = {
        Equal: {
          n: "exhibitorId",
          v: this.exhibitorId,
        },
        equal_isShow: {
          n: "isShow",
          v: 1,
        },
        EqualB: {
          n: "auditState",
          v: 1,
        },
      };
      let order = [
        {
          N: "showIndex",
          v: 0,
        },
        {
          N: "createAt",
          v: 0,
        },
      ];
      this.$apollo.addSmartQuery("queryProduct", {
        query: query,
        variables: {
          page: this.pageIndex,
          size: this.pageSize,
          where: JSON.stringify(where),
          order: JSON.stringify(order),
        },
        fetchPolicy: "network-only", //清理缓存
        result(data) {
          console.log("展品", data);
          let res = JSON.parse(JSON.stringify(data.data.queryProduct));
          // let res=data.data.queryProduct;
          if (res && res.items.length) {
            res.items.forEach((e) => {
              if (e.banner && !Array.isArray(e.banner)) {
                e.banner = JSON.parse(e.banner);
              } else if (!Array.isArray(e.banner)) {
                e.banner = [];
              }
              if (e.category && e.category.indexOf("{") !== -1) {
                let cate = JSON.parse(e.category);
                if (Array.isArray(cate)) {
                  e.category = this.getCate(cate);
                } else {
                  e.category = this.getProCate(cate);
                }
              }
              if (e.categoryEn && e.categoryEn.indexOf("{") !== -1) {
                let cate = JSON.parse(e.categoryEn);
                if (Array.isArray(cate)) {
                  e.categoryEn = this.getCate(cate);
                } else {
                  e.categoryEn = this.getProCate(cate);
                }
              }
            });
          }
          
          // console.log(this.pageIndex,'2211233132111');
          if (this.pageIndex == 1) {
            this.List = res.items;
          } else {
            this.List = [...new Set([...this.List, ...res.items])];
          }
          console.log('this.List',this.List);
          this.Loading = false;
          if (isLoad) {
            this.pageIndex = res.pageIndex;
          } else {
            this.pageIndex = 0;
            this.pageSize = 10;
          }
          if (!res.hasNextPage) {
            this.finished = true;
          }
        },
        error(err) {
          this.Loading = false;
          console.log("err", err);
        },
      });
    },
    getCate(arr) {
      let str = "";
      if (arr && arr[0]) {
        for (let i = 0; i < arr.length; i++) {
          str += str ? "," + arr[i].Value : arr[i].Value;
        }
        return str;
      } else {
        return "";
      }
    },
    loadMore() {
      if (this.finished) return;
      this.Loading = true;
      this.pageIndex += 1;
      this.getData(true);
    },
  },
};
</script>

<style scoped lang="scss">
//展品列表
.exhibits_list {
  margin-top: 0.2rem;
  background: #fff;
  border-radius: 0.3rem;
  padding: 0.2rem 0.25rem 0;
  color: #333;
  .title {
    height: 0.77rem;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: 0.32rem;
      font-weight: bold;
      margin: 0 0.2rem;
    }
    img {
      height: 0.2rem;
      width: 0.42rem;
    }
  }
  .ex_list {
    .item_div {
      padding: 0.26rem 0;
      border-bottom: 1px solid #e6e6e6;
      display: flex;
      &:last-child {
        border: none;
      }
      .img_div {
        flex-shrink: 0;
        position: relative;
        height: 1.6rem;
        width: 1.6rem;
        border-radius: 2px;
        border: 1px solid #e6e6e6;
        overflow: hidden;
        margin-right: 0.2rem;
        img {
          width: 100%;
          height: 100%;
          // object-fit: cover;
        }
        .d_tag {
          position: absolute;
          z-index: 1;
          width: 0.8rem;
          height: 0.35rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #ff5c00;
          padding: 0 0.13rem 0 0.05rem;
          box-sizing: border-box;
          border-radius: 0 0 0 0.1rem;
          color: #fff;
          font-size: 0.2rem;
          right: 0;
          top: 0;
          .iconfont {
            font-size: 0.36rem;
          }
        }
        .img-v {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 2;
          color: #0190fe;
          width: 0.38rem;
          border: 1px solid #0190fe;
          display: flex;
          align-content: center;
          justify-content: center;
          background-color: #fff;
        }
        .play_video {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(0, 0, 0, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
          i {
            font-size: 0.72rem;
            color: #fff;
          }
        }
      }
      .item_info {
        max-width: calc(100% - 1.8rem);
        p {
          font-size: 0.26rem;
          font-weight: bold;
          margin-top: 0.1rem;
          &.name{
            min-height: 0.34rem;
          }
          &.item_text {
            color: #666;
            font-weight: inherit;
            font-size: 0.24rem;
            margin-top: 0.1rem;
          }
        }
      }
    }
  }
  .more_btn {
    font-size: 0.26rem;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 0.75rem;
    width: calc(100% + 0.5rem);
    margin-left: -0.25rem;
    border-top: 1px solid #e6e6e6;
    color: #999;
    &.loading {
      text-align: center;
      img {
        width: 0.3rem;
        height: 0.3rem;
        margin-right: 0.1rem;
        animation: 1s loader-01 linear infinite;
      }
    }
    .iconfont {
      color: #999;
      display: inline-block;
      transform: rotate(90deg) translateX(1px);
      &.shang {
        transform: rotate(-90deg) translateX(-1px);
      }
    }
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
